import { render } from "./HeroiconsOutlineViewGrid.vue?vue&type=template&id=2129fd0c"
const script = {}

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineViewGrid.vue"]])

export default __exports__